import { Box, Option, Select, SxProps } from '@modusign/design-system';

interface LimitOption {
  text: string;
  value: number;
}

const defaultOptions: LimitOption[] = [
  { text: '10개씩 보기', value: 10 },
  { text: '20개씩 보기', value: 20 },
  { text: '35개씩 보기', value: 35 },
  { text: '50개씩 보기', value: 50 },
  { text: '100개씩 보기', value: 100 },
];

interface SelectLimitProps extends SxProps {
  className?: string;
  limit: number;
  options?: LimitOption[];
  onChange: (limit: number) => void;
}

export default function SelectLimit({
  className,
  limit,
  sx,
  options = defaultOptions,
  onChange,
}: SelectLimitProps) {
  return (
    <Box sx={{ width: '130px', ...sx }}>
      <Select
        className={className}
        data-testid="select-limit"
        value={limit}
        onChange={(e) => onChange(parseInt(e.target.value, 10))}
      >
        {options.map((option) => (
          <Option key={option.value} value={option.value}>
            {option.text}
          </Option>
        ))}
      </Select>
    </Box>
  );
}
